import { useQuery } from "react-query";
import { getChats, type Chat } from "../services/api";

/**
 * Hook per ottenere la lista delle chat usando React Query
 */
export function useChats() {
  return useQuery<Chat[], Error>("chats", getChats, {
    staleTime: 1000 * 60 * 5, // 5 minuti
    cacheTime: 1000 * 60 * 10, // 10 minuti
  });
}
